import {
  BenefitItem,
  Benefits,
  Inner,
  ItemDescription,
  ItemImage,
  Title,
  Wrapper,
} from './whyQodeca.styles';
import { IWhyQodeca } from './interfaces';
import { RichText } from 'prismic-reactjs';
import Image from 'next/image';
import { imageSerializer } from 'utils/imageSerializer';

export const WhyQodeca = ({ titleAs, title, benefits }: IWhyQodeca) => {
  return (
    <Wrapper>
      <Inner>
        <Title as={titleAs && titleAs}>{title}</Title>
        <Benefits>
          {benefits.map((el) => {
            const description = RichText.asText(el.benefit_description);
            return (
              <BenefitItem key={description}>
                <ItemImage>
                  <Image {...imageSerializer(el.benefit_image)} />
                </ItemImage>
                <ItemDescription>{description}</ItemDescription>
              </BenefitItem>
            );
          })}
        </Benefits>
      </Inner>
    </Wrapper>
  );
};
